function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Button, Form, Input, InputNumber, Space, Alert } from 'antd';
import axios from 'axios';
import Common from "../../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var EditUserOrganization = function EditUserOrganization(_ref) {
  var handler = _ref.handler,
    organization = _ref.organization;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1];
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setErrorMessage('');
    var formData = new FormData();
    formData.append("id", organization.id);
    formData.append('label', values.label);
    formData.append('mobile', values.mobile);
    formData.append('email', values.email);
    formData.append('address', values.address);
    formData.append('logo', file);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'edituserorganization', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        handler();
      } else {
        window.scrollTo(0, 0);
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      window.scrollTo(0, 0);
      setIsFormLoading(false);
      setErrorMessage('Une erreur s\'est produite, ' + error.message);
    });
  };
  useEffect(function () {
    if (organization != null) form.setFieldsValue({
      label: organization.label,
      email: organization.email,
      mobile: organization.mobile,
      address: organization.address
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h6", {
      style: {
        color: '#645D5D'
      },
      children: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER VOTRE STRUCTURE"
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "middle",
      form: form,
      onFinish: onFinish,
      autoComplete: "off",
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          banner: true,
          closable: true,
          style: {
            marging: '5px 0px',
            fontSize: '14px'
          },
          message: errorMessage,
          type: "error",
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "Nom de la structure",
        rules: [{
          required: true,
          message: 'Veuillez entrer le nom de la structure'
        }],
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: "Entrer le nom de la structure"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "T\xE9l\xE9phone",
        name: "mobile",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "email",
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: "Votre e-mail"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "address",
        children: /*#__PURE__*/_jsx(TextArea, {
          placeholder: "Entrez votre adresse",
          autoSize: {
            minRows: 2,
            maxRows: 3
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: organization == null,
          loading: isFormLoading,
          type: "primary",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "SAUVEGARDER"
          })
        })
      })]
    })]
  });
};
export default EditUserOrganization;